/** Defines special Address' kind that means kind is search map area */
export const MAP_AREA_KIND = 'map_area'
